import { API_V4 } from "@/services/config/auth-axios";

class DashboardService {
  getBanner(item) {
    return API_V4.get(`/users/dashboard/sliders?type=${item}`);
  }
  getLatestOrders(count) {
    return API_V4.get(`/users/dashboard/orders?count=${count}`);
  }
  getLatestCurrencies(count) {
    return API_V4.get(`/users/dashboard/currencies?count=${count}`);
  }
  getCampaigns() {
    return API_V4.get("/users/dashboard/campaigns");
  }
}

export default new DashboardService();
